// src/components/Title.jsx
import React from 'react';
import PropTypes from 'prop-types';

const Title = ({ text, className }) => {
  return <h2 className={className}>{text}</h2>;
};

Title.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default Title;
